import React from "react";
import img from "../../img/acParts.webp";
import Progress from "../Shared/Progress";
const Extra2 = () => {
  return (
    <div class="hero min-h-screen bg-gray-200 mt-10">
      <div class="hero-content flex-col lg:flex-row">
        <img className="h-[500px]" src={img} />
        <div className="justify-center">
          <h1 class="text-5xl text-cyan-800 font-bold">OUR EXPERIENCE</h1>
          <p class="py-6">We are Working world With 20+ Years experience</p>
          <div className="flex gap-2">
            <button className="btn btn-primary bg-cyan-800 text-white">
              Our mission
            </button>
            <button className="btn btn-primary bg-cyan-800 text-white">
              Our Vision
            </button>
          </div>
          <p className="mt-5 mb-5">
            The best things about my team is the openness of the group to hear
            other people out and help others.
          </p>
          <div>
            <Progress></Progress>
          </div>
          <progress class="progress w-76"></progress>
        </div>
      </div>
    </div>
  );
};

export default Extra2;
